import React, { useState, useEffect } from "react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import {
  Table,
  Select,
  Loader,
  Button,
  Pagination,
  Popup
} from "semantic-ui-react";
import { Container, Content, Center, Text, Header, Sentence } from './styled'
import { pb4y as api, pb4yLocal as local } from "../../../../services/apis";

import { BiSearch } from 'react-icons/bi'
import { Box } from "@material-ui/core";

const options = [
  { key: 'BR', value: 'BR', text: 'Português' },
  { key: 'EN', value: 'EN', text: 'Inglês' },
  { key: 'ES', value: 'ES', text: 'Espanhol' },
  { key: 'DE', value: 'DE', text: 'Alemão' },
  { key: 'RU', value: 'RU', text: 'Russo' },
  { key: 'ZH', value: 'ZH', text: 'Chinês' },
  { key: 'FR', value: 'FR', text: 'Francês' },
  { key: 'IT', value: 'IT', text: 'Italiano' }
]

function Evaluation() {
  const [articleRates, setArticleRates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lang, setLang] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [sentences, setSentences] = useState([]);

  useEffect(() => {
    async function getDate() {
      setLoading(true)
      const langFilter = lang ? `&lang=${lang}` : '';

      await api.get(`/total-article-rate?page=${page}${langFilter}`).then(res => {
        console.log(res.data)
        setArticleRates(res.data.items)
        setTotalPages(res.data.pages)
        setLoading(false)
      }).catch(err => {
        setLoading(false)
        console.error(err);
      })

      await api.get('/evaluation-sentence').then(res => {
        setSentences(res.data.items)
      }).catch(err => console.error(err))
    }
    getDate()
  }, [lang, page])

  const handleArticleRate = (articleRate) => {
    const newArticleRate = { titulo: '', url: '', medium: 0, ...articleRate };

    newArticleRate.medium = Math.round(articleRate.medium_rate * 10) / 10;
    if(articleRate.article){
      newArticleRate.titulo = articleRate.article.titulo;
      newArticleRate.url = articleRate.article.url;
    }

    return newArticleRate;
  }

  return (
    <Box width="100%" paddingLeft="250px">
    <Box width="100%" padding="1rem">
      <AdminMenu />
        <Box>
        <Content>
          <h1>Avaliação dos Livros</h1>

          <Header>
            {sentences.map(sentence => (
              <Sentence>
                <p>{sentence.name}</p>
                <span>{sentence.count_times}</span>
              </Sentence>
            ))}
          </Header>

          <Center space>
            <Pagination
              boundaryRange={0}
              activePage={page}
              defaultActivePage={1}
              onPageChange={(e, f) => setPage(f.activePage)}
              firstItem={null}
              lastItem={null}
              totalPages={totalPages}
            />

            <div>
              <Select placeholder='Selecionar idioma' value={lang.text} options={options}
                onChange={(e, data) => setLang(data.value)} />
              <Button primary onClick={() => setLang('')}>Limpar</Button>
            </div>
          </Center>

          <Table stackable>
            <Table.Header>
              <Table.HeaderCell>
                <Center>Titulo</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>URL</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>1 estrela</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>2 estrelas</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>3 estrelas</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>4 estrelas</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>5 estrelas</Center >
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Media de estrelas</Center >
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Sentenças</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Linguagem</Center>
              </Table.HeaderCell>
              <Table.HeaderCell >
                <Center>Mais</Center>
              </Table.HeaderCell>
            </Table.Header>

            <Table.Body>
              {loading ? <Loader active={loading} /> :
                articleRates.length !== 0 ? articleRates.map((articleRate, index) => {
                  const evaluation = handleArticleRate(articleRate)
                  
                  return (
                    <Table.Row>
                      <Table.Cell >
                        <Center>{evaluation.titulo}</Center>
                      </Table.Cell>
                      <Table.Cell >
                        <Center>{evaluation.url}</Center>
                      </Table.Cell>
                      <Table.Cell >
                        <Center>{evaluation.one_star}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{evaluation.two_star}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{evaluation.three_star}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{evaluation.four_star}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{evaluation.five_star}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{evaluation.medium}</Center>
                      </Table.Cell>
                      <Table.Cell >
                        <Center> <Popup trigger={<Button icon='eye'/>} > {evaluation.sentence.map(es => <p>{es.name}</p>)} </Popup> </Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{evaluation.lang}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Button onClick={() => window.open(`/admin/pocketbook/avaliacoes/detalhes/${evaluation.id_article}`)}>
                          <BiSearch size={22} />
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  )
                }) : <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell colSpan='7'>
                      <Text>Nenhuma livro encontrado</Text>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>}
            </Table.Body>
          </Table>
        </Content>
        </Box>
      </Box>
    </Box>
  )
}

export default Evaluation;
